import Model from '@/models/Model.js';

export default class AcknowledgeInformationActivityTemplate extends Model {
    static entity = 'acknowledge_information_activity_templates';

    static modelName = 'AcknowledgeInformationActivityTemplate';

    static fields() {
        return {
            content: this.attr(null),
            acknowledgment_message: this.attr(null),

            ...super.fields(),
        };
    }
}
